"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightColumn = exports.LeftColumn = exports.StyledSelectTopic = exports.SelectAudience = exports.navLinkStyle = exports.TopicText = exports.AudienceText = exports.HiddenLabel = exports.NavWidgetStyled = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _button = require("@berlitz/button");
var _select = _interopRequireDefault(require("@berlitz/select"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var NavWidgetStyled = _styledComponents.default.div.withConfig({
  displayName: "NavWidgetstyle__NavWidgetStyled",
  componentId: "sc-1qjc1zv-0"
})(["padding:", ";border-radius:", ";background-color:", ";box-shadow:", ";display:flex;flex-wrap:wrap;width:100%;@media (min-width:", "){justify-content:center;padding:", " ", ";}@media (min-width:", "){max-width:100%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radius.md;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.ui00;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.elevation.md;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.sm;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spaceLg;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.lg;
});
exports.NavWidgetStyled = NavWidgetStyled;
var textStyle = (0, _styledComponents.css)(["", " margin-bottom:1px;flex-shrink:0;@media (min-width:", "){", " &:first-child{padding-top:0;}}@media (max-width:", "){margin-top:", ";}"], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: ", ";\n    margin-right: ", ";\n    text-align: left;\n  "])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.xxs;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.sm;
}), function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.md;
}, (0, _styledComponentsRtl.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding-right: ", ";\n      margin-right: 0;\n    "])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.xs;
}), function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.lg;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.sm;
});
var HiddenLabel = _styledComponents.default.label.withConfig({
  displayName: "NavWidgetstyle__HiddenLabel",
  componentId: "sc-1qjc1zv-1"
})(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
exports.HiddenLabel = HiddenLabel;
var AudienceText = _styledComponents.default.div.withConfig({
  displayName: "NavWidgetstyle__AudienceText",
  componentId: "sc-1qjc1zv-2"
})(["", ""], textStyle);
exports.AudienceText = AudienceText;
var TopicText = _styledComponents.default.div.withConfig({
  displayName: "NavWidgetstyle__TopicText",
  componentId: "sc-1qjc1zv-3"
})(["", " width:100%;margin-bottom:", ";@media (min-width:", "){width:auto;margin-bottom:0;}"], textStyle, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.sm;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoints.md;
});
exports.TopicText = TopicText;
var navLinkStyle = (0, _styledComponents.css)(["", ";display:flex;justify-content:center;padding:", ";font-weight:", ";margin-top:", ";transition:", ";margin-top:0;transition:background 0.8s;@media (min-width:", "){padding:", ";", " width:auto;}"], _button.buttonStyle, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.space.sm);
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontWeight.bold;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.sm;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.animation.transitionMedium;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.breakpoints.md;
}, function (_ref22) {
  var theme = _ref22.theme;
  return "".concat(theme.space.sm, " ").concat(theme.space.xxl);
}, (0, _styledComponentsRtl.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-left: ", ";\n    "])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.space.xl;
}));
exports.navLinkStyle = navLinkStyle;
var selectStyle = (0, _styledComponents.css)(["display:flex;margin-bottom:", ";@media (min-width:", "){margin:0;}select{color:", ";", " border-color:", ";}"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.space.md;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.breakpoints.md;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colorBrand01;
}, (0, _styledComponentsRtl.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      text-align: left;\n      text-align-last: left;\n    "]))), function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.ui03;
});
var SelectAudience = (0, _styledComponents.default)(_select.default).withConfig({
  displayName: "NavWidgetstyle__SelectAudience",
  componentId: "sc-1qjc1zv-4"
})(["", " flex-grow:1;margin-bottom:", ";@media (min-width:", "){flex:1 0 auto;}@media (min-width:", "){flex:1 0 auto;}"], selectStyle, function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.xs;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.breakpoints.sm;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.breakpoints.xxl;
});
exports.SelectAudience = SelectAudience;
var StyledSelectTopic = (0, _styledComponents.default)(_select.default).withConfig({
  displayName: "NavWidgetstyle__StyledSelectTopic",
  componentId: "sc-1qjc1zv-5"
})(["", " flex:1 0 0;margin-bottom:", ";@media (min-width:", "){flex:1 0 auto;width:auto;", "}@media (max-width:", "){margin:14px auto;}"], selectStyle, function (_ref31) {
  var theme = _ref31.theme;
  return theme.space.xs;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.breakpoints.md;
}, (0, _styledComponentsRtl.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "])), function (_ref33) {
  var theme = _ref33.theme;
  return theme.space.md;
}), function (_ref34) {
  var theme = _ref34.theme;
  return theme.breakpoints.lg;
});
exports.StyledSelectTopic = StyledSelectTopic;
var LeftColumn = _styledComponents.default.div.withConfig({
  displayName: "NavWidgetstyle__LeftColumn",
  componentId: "sc-1qjc1zv-6"
})(["display:flex;width:100%;align-items:baseline;@media (min-width:", "){display:flex;width:100%;flex-grow:0;padding:", " 0;align-items:center;flex:1 0 auto;}@media (min-width:", "){width:auto;}"], function (_ref35) {
  var theme = _ref35.theme;
  return theme.breakpoints.lg;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.xs;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.breakpoints.xl;
});
exports.LeftColumn = LeftColumn;
var RightColumn = _styledComponents.default.div.withConfig({
  displayName: "NavWidgetstyle__RightColumn",
  componentId: "sc-1qjc1zv-7"
})(["display:block;width:100%;align-items:baseline;@media (min-width:", "){display:flex;width:100%;padding:", " 0;align-items:center;}@media (min-width:", "){flex-grow:1;width:auto;", "}"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.breakpoints.lg;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.space.xs;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.xl;
}, (0, _styledComponentsRtl.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      padding-left: ", ";\n    "])), function (_ref41) {
  var theme = _ref41.theme;
  return theme.space.xs;
}));
exports.RightColumn = RightColumn;